import { IMAGE_VIEWERS } from "../../constants/constants";
import { FETCH_ALL_GROUPS_START, FETCH_ALL_GROUPS_SUCCESS, FETCH_ALL_GROUPS_ERROR } from "../actions/groupsAction";

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    groups: []
};

const integratorReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_ALL_GROUPS_START: {
            return { ...state, error: '', message: '', loading: true }
        }
        case FETCH_ALL_GROUPS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, groups: action.groups.length > 0 ? [...action.groups] : [] }
        }

        case FETCH_ALL_GROUPS_ERROR: {
            return { ...state, error: '', message: '', loading: false, sessionCreated: false }
        }

        default:
            return state;
    }
}

export default integratorReducer;
